import { registerLocaleData } from '@angular/common' // Import function to register locale data
import localeEs from '@angular/common/locales/es'
import localeFr from '@angular/common/locales/fr'
import { bootstrapApplication } from '@angular/platform-browser'

import { initializeLanguage } from '@yoshu-lib/core/config/language.factory'

import { AppComponent } from './app/app.component'
import { appConfig } from './app/app.config'

// registers French and Spanish locale data for internationalization support
registerLocaleData(localeFr)
registerLocaleData(localeEs)

bootstrapApplication(AppComponent, appConfig)
  .then((appRef) => initializeLanguage(appRef.injector))
  .catch((err) => {
    console.error('Failed to bootstrap application:', err)
    console.error('Error details:', {
      message: err?.message,
      stack: err?.stack,
      name: err?.name
    })

    // Display user-friendly error message
    const appRoot = document.querySelector('app-root')
    if (appRoot) {
      appRoot.innerHTML = `
        <div style="display: flex; flex-direction: column; align-items: center; justify-content: center; height: 100vh; padding: 20px; text-align: center; font-family: system-ui, -apple-system, sans-serif;">
          <h1 style="color: #dc2626; margin-bottom: 16px;">Application Failed to Load</h1>
          <p style="color: #4b5563; margin-bottom: 24px; max-width: 500px;">
            We encountered an error while starting the application. Please try refreshing the page.
          </p>
          <button
            onclick="window.location.reload()"
            style="background: #2563eb; color: white; padding: 12px 24px; border: none; border-radius: 6px; cursor: pointer; font-size: 16px;"
          >
            Refresh Page
          </button>
          <details style="margin-top: 32px; max-width: 600px; text-align: left;">
            <summary style="cursor: pointer; color: #6b7280;">Technical Details</summary>
            <pre style="background: #f3f4f6; padding: 16px; border-radius: 6px; overflow: auto; margin-top: 12px; font-size: 12px;">${err?.message || 'Unknown error'}\n\n${err?.stack || ''}</pre>
          </details>
        </div>
      `
    }

    // Hide the loader if it's still visible
    const loader = document.getElementById('app-loader')
    if (loader) {
      loader.classList.add('loaded')
      setTimeout(() => loader.remove(), 300)
    }
  })
